// My Vuex Store
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import * as firebase from "firebase";
import firebaseui from "firebaseui";
import 'firebaseui/dist/firebaseui.css'

import { firebaseConfig } from './database.js'

import {video, toUrl} from './helper.js'

export const firebaseApp = firebase.initializeApp(firebaseConfig);
const auth = firebaseApp.auth();

import QuestionLoader from './questions/question-loader.js'

auth.onAuthStateChanged((user) => {
	// console.log('User: ', user)

	if(user){
		console.log(user.isAnonymous ? 'Gast.' : 'Eingeloggt.', user.uid)

		if(user.isAnonymous){
			firebase.database().ref('/users/' + user.uid).set({
				uid: user.uid,
				isAnonymous: true
			})
		}

		store.commit('setDB', firebaseApp)
		store.dispatch('user', user)
		// store.dispatch('loadQuizzes')
	}else{

		firebase.auth().signInAnonymously().catch(function(error) {
			console.log('Error in signInAnonymously', error.code, error.message)
		});

		// console.log('Didn\'t get it')
	}
})

export const store = new Vuex.Store({
	state: {
		user: {uid: null},
		ui: new firebaseui.auth.AuthUI(firebaseApp.auth()),
		db: null,
		fb: null,
		quizzes: [],
		publicQuizzes: [],
		quiz: null
		// lastAddedQuizKey: null
	},
	mutations: {

		

		addFame( state, obj){
			state.quiz.hallOfFame.push(obj)
		},

		removeFame( state, obj){
			// console.log('Entferne Fame.', obj)
			state.quiz.hallOfFame = state.quiz.hallOfFame.filter( v => v.key != obj.fameKey)
		},

		questionAnswered( state, questionKey ){
			// console.log('questionAnswered', questionKey)
			state.db.ref('/sprints/' + state.user.uid + '/' + state.quiz.key + '/answered/' + questionKey).set(true)
			state.quiz.questions[questionKey].answered = true
		},

		quizSolved( state ){
			// console.log('Quiz solved')

			state.quiz.solved = true
			state.db.ref('/sprints/' + state.user.uid + '/' + state.quiz.key + '/endTime').set(firebase.database.ServerValue.TIMESTAMP)

			state.db.ref('/sprints/' + state.user.uid + '/' + state.quiz.key).once('value', snapshot => {
				let sprint = snapshot.val()
				let duration = sprint.endTime - sprint.startTime

				state.db.ref('hallOfFame/' + state.quiz.key).push({
					time: firebase.database.ServerValue.TIMESTAMP,
					duration: duration,
					username: state.user.displayName,
					userid: state.user.uid,
					photo: state.user.photoURL
				})

				state.quiz.endTime = sprint.endTime
			})
		},

		setQuiz( state, quiz){
			// console.log('mutations/setQuiz', quiz)
			// quiz.restartTriggered = false
			state.quiz = quiz
		},

		quizLoadFailed( state, key){
			console.log('Failed loading Quiz with key: ', key)
			state.quiz = {failed: true}
		},

		updateStartTime( state, st){
			state.quiz.startTime = st
		},

		resetQuiz( state ){
			// console.log('resetQuiz, quizKey: ', state.quiz.key)
			// state.db.ref('hallOfFame/' + state.quiz.key).off()
			state.quiz = null

		},

		updateQuizzes(state, quizzes){
			console.log(':::---::: store/updateQuizzes', quizzes)
			state.quizzes = quizzes
		},
		setPublicQuizzes(state, quizzes){
			state.publicQuizzes = quizzes
		},

		updateQuiz( state, obj){
			console.log('updateQuiz', obj)

			/* delete hallOfFame */
			// state.db.ref('/hallOfFame/' + obj.key).remove()

			/* delete current Sprints */
			state.db.ref('/sprints').once( "value", snap => {
				// console.log('Sprint Snap: ', snap.val())

				for(let userSprintKey in snap.val()){
					let userSprint = snap.val()[userSprintKey]

					for(let sprintKey in userSprint){
						if(sprintKey == obj.key){
							state.db.ref('/sprints/' + userSprintKey + '/' + sprintKey).remove()
						}
					}
				}
			})

			/* update Quiz */
			state.db.ref('/quizzes/' + obj.key).update({creator: state.user.displayName, uid: state.user.uid, ...obj.quiz})

			/* save that he did it */
			state.db.ref('/users/' + state.user.uid + '/quizzes/' + obj.key).set(true)

			/* save its key */
			state.db.ref('/quizKeys/' + toUrl(obj.quiz.name)).set(obj.key)

			/* save as public or delete from public eyes */
			if(obj.quiz.public){
				state.db.ref('/publicQuizzes/' + obj.key).set(true)
			}else{
				state.db.ref('/publicQuizzes/' + obj.key).remove()
			}

		},
		removeQuiz( state, key){
			// console.log('store/mutations/removeQuiz', key)

			state.db.ref('/quizzes/' + key).remove()

			/* remove from users list */
			state.db.ref('/users/' + state.user.uid + '/quizzes/' + key).remove()

			delete state.quizzes[key]
		},
		setUser (state, user){
			// console.log(':::---:::  mutations', state, user)

			user.isAdmin = (user.uid == 'Ag71aaRbPaPyvMTz3MkXvys9B7d2' || user.uid == 'NGxPZFky33c4CpIM7JXNfzYBVhv2')

			// console.log('User.isAdmin: ', user.isAdmin)

			if(!user.isAdmin){
				var console = {};
				console.log = function(){};
				console.warn = window.console.warn
				console.error = window.console.error
				console.info = window.console.info
				window.console = console;
			}

			state.user = user
		},
		resetUser( state ){
			// console.log(':::---:::  resetUser')
			state.user = {uid: null}
			store.state.quizzes = []
		},
		setDB( state, fb ){
			// console.log(':::---:::  mutations/setDB')
			state.fb = fb
			state.db = fb.database()
		},

		addQuiz( state, quiz){
			state.quizzes[quiz.key] = quiz
			// state.lastAddedQuizKey = quiz.key
			store.commit('updateQuiz', {key: quiz.key, quiz: quiz})
		}
	},
	actions: {

		deleteFame( context, obj){
			// console.log('Delete Fame in Store', obj.quizKey, obj.fameKey)
			store.state.db.ref('/hallOfFame/' + obj.quizKey + '/' + obj.fameKey).remove()
		},
		startQuiz( context, quizKey){
			// console.log('Start Quiz ', quizKey)

			/*
			* delete old sprint, load quiz which creates a new sprint
			*/
			const userQuizRef = '/sprints/' + store.state.user.uid + '/' + quizKey;
			store.state.db.ref(userQuizRef).remove().then(() => {
				// console.log('remove fertig')
				context.dispatch('loadQuiz', quizKey)
			})
		},

		loadQuizByName( context, name){
			store.state.db.ref('/quizKeys/' + name).once('value', (snap) => {
				console.log('loadQuizByName: ', name, snap.val(), snap.key)

				context.dispatch('loadQuiz', snap.val())
			});
		},

		loadQuiz( context, key){
			console.log('loadQuiz', key)

			/* remove evtl old watchers from hallOfFame */
			store.state.db.ref('hallOfFame/' + key).off()

			// TODO: stoa? store? musses nich context sein?
			store.state.db.ref('/quizzes/' + key).once('value', (snapshot) => {

				const quiz = snapshot.val()
				console.log('Load Quiz: ', quiz)

				if(!quiz){
					console.log('Loading adsf')

					context.commit('quizLoadFailed', key)
					return 'Loading failed.'
				}

				quiz.description = video(quiz.description)

				// const userQuizRef = '/user-variables/' + key + '/' + store.state.user.uid;
				const userQuizRef = '/sprints/' + store.state.user.uid + '/' + key;

				store.state.db.ref(userQuizRef).once('value', (usersnap) => {
					// console.log('Load Sprint: ', usersnap.val(), quiz)
					var userVariables 	 = {}
					var sprint = usersnap.val()

					/* 
					* load user variables - create some if none existent yet 
					*/
					if( usersnap.val() == null ){
						// console.log('no variables', userVariables)

						/* set the variables */
						quiz.variables && quiz.variables.forEach( v => {
							// console.log('v: ', v)
							userVariables[v.name] = Math.floor(Math.random()* (parseInt(v.to) - parseInt(v.from) + 1) + parseInt(v.from))

							/* kleiner fail safe wegen nullern*/
							if(parseInt(v.from) < 0 && parseInt(v.to) > 0 && userVariables[v.name] == 0) {
								userVariables[v.name] = 1
							}
							// console.log('Result: ', userVariables[v.name])
						})

						store.state.db.ref(userQuizRef).set({
							startTime: firebase.database.ServerValue.TIMESTAMP,
							variables: userVariables
						}, v => {
							store.state.db.ref(userQuizRef).once('value', t => {
								// console.log('Look, der Sprint ging los.', t.val())
								context.commit('updateStartTime', t.val().startTime)
							})
						})
					}else{
						// console.log('he got variables', usersnap.val())
						userVariables = usersnap.val() != null && usersnap.val().variables ? usersnap.val().variables : userVariables

						if(usersnap.val().endTime)
							quiz.solved = true
					}

					/* 
					* replace holders in answers and alternatives based on user variables 
					*/
					for(var variableKey in userVariables){
						const f = ':' + variableKey + ':'
						const t = userVariables[variableKey]

						quiz.questions.forEach( (question, i, arri) => {
							try{
								arri[i] = QuestionLoader.fill(f, t, question)
							}catch(e){
								console.log('::::', e)
								arri[i] = question
							}
						})
					}

					// console.log('Quiz hier: ', quiz)
					// console.log('usersnap: ', usersnap.val())

					/* 
					* evaluate answer and alternative answer 
					*/
					quiz.questions && quiz.questions.forEach( (question, i, arri) => {
						// console.log('im store foreach. question: ', question, i)

						try{
							arri[i] = QuestionLoader.evaluate(question, i)
						}catch(e){
							arri[i] = question
						}

						/* save if he already got it right
						* TODO: Cope with fucking nulls man, nobody can read this shit 
						*/
						arri[i].answered = usersnap.val() != null && usersnap.val().answered != null && usersnap.val().answered[i] ? true : false
					})

					/*
					* load hall of fame
					*/
					// console.log('vor hallOfFame')
					var hallOfFame = []
					store.state.db.ref('hallOfFame/' + key).on('child_added', f => {
						// console.log('child_added in hallOfFame triggered', f.val(), f.key)
						// hallOfFame.push({key: f.key, ...f.val()})
						context.commit('addFame', {key: f.key, ...f.val()})
					})
					store.state.db.ref('hallOfFame/' + key).on('child_removed', f => {
						// console.log('child_removed in hallOfFame triggered', f.val(), f.key)
						context.commit('removeFame', {fameKey: f.key, quizKey: key})
					})

					// let startTime = usersnap.val() ? usersnap.val().startTime : Date.now()
					let startTime = usersnap.val() ? usersnap.val().startTime : 0
					// let endTime = usersnap.val() ? usersnap.val().endTime : Date.now()
					let endTime = usersnap.val() ? usersnap.val().endTime : 0
					context.commit('setQuiz', {key: snapshot.key, ...quiz, startTime: startTime, endTime: endTime, hallOfFame: hallOfFame, restart: false})
				})
			}, function(e) {
  				// This is called
  				console.log('MIESER FEHLER', e)
  			})
			//maan
		},
		loadQuizzes( context ){

			console.log('User: ', store.state.user.uid )

			//  
			store.state.quizzes.length == 0 && store.state.db.ref('/users/' + store.state.user.uid + '/quizzes').once('value', q => {
				console.log('Receive in loadQuizzes', q.val(), q.key)

				let Quizzes = {}
				let P = []

				q.val() && Object.keys(q.val()).forEach( v => {
					P.push(
						store.state.db.ref('/quizzes/' + v).once('value', s => {
							Quizzes[v] = {key: v, ...s.val()}
						}))
				})

				Promise.all(P).then( () => {
					context.commit('updateQuizzes', Quizzes)
				})

			})


			// store.state.quizzes.length == 0 && store.state.db.ref('/quizzes').on('value', (snapshot) => {
			// 	console.log('store/loadQuizzes')

			// 	context.commit('updateQuizzes', snapshot.val())
			// })
		},
		loadPublicQuizzes( context){

			let publicQuizzes = []

			store.state.publicQuizzes.length == 0 && store.state.db.ref('/quizzes').once('value', (snap) => {
				snap.val() && Object.keys(snap.val()).forEach( (v, i) => {
					// console.log('Public Quiz: ', v, i, snap.val()[v])
					if(snap.val()[v].public){	
						// publicQuizzes[v] = snap.val()[v]
						publicQuizzes.push({key: v, ...snap.val()[v]})
					}
				})

				// console.log('All the public Quizzes: ', publicQuizzes)
				// context.commit('setPublicQuizzes', publicQuizzes)
				publicQuizzes.sort( (a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)
				// console.log('All the public Quizzes:2 ', publicQuizzes)
				context.commit('setPublicQuizzes', publicQuizzes )
			})


			/* das sind doch viel zu viele Datenbankaufrufe */
			// store.state.publicQuizzes.length == 0 && store.state.db.ref('/publicQuizzes').once('value', pq => {
			// 	console.log('Public Quizzes: ', pq.val())

			// 	let publicQuizzes = []

			// 	pq.val() && Object.keys(pq.val()).forEach( (v, i) => {
			// 		console.log('Public Quiz: ', v, i)

			// 		store.state.db.ref('/quizzes/' + v).once('value', quiz => {

			// 		})

			// 		publicQuizzes.push()
			// 	})

			// 	context.commit('setPublicQuizzes', publicQuizzes)
			// })
		},

		user( context, user ){
			// console.log('Bin eine Action', context, user)
			context.commit('setUser', user)
			// context.commit('setDB')
		},
		logout( context ){
			// console.log('Outlogging im Store')
			// this.props.history.push("/");

			auth
			.signOut()
			.then(function() {
				// console.log("Sign-out successful.");
				context.commit('resetUser')
			})
			.catch(function(error) {
				// console.log("An error happened.");
			});
		}
	}
})


// WEBPACK FOOTER //
// ./src/store.js